import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Locale } from 'api';

interface LocaleDefProps {
  field: string;
  headerName: string;
  locales: Locale[];
}

export function generateLocaleDef({
  field,
  headerName,
  locales,
}: LocaleDefProps): GridColDef {
  return {
    field,
    headerName,
    width: 150,
    editable: true,
    renderCell: ({ value = '' }) => (
      <>{locales.find(({ code }) => code === value)?.title}</>
    ),
    renderEditCell: ({ id, field, value, api }) => {
      const setLocaleCode = (event: SelectChangeEvent<string>) => {
        api.setEditCellValue({
          id,
          field,
          value: event.target.value,
        });
      };

      return (
        <>
          <FormControl fullWidth>
            <Select
              value={`${value}`}
              label="Locale"
              onChange={setLocaleCode}
            >
              {locales.map(({ code, title }) => (
                <MenuItem key={code} value={code}>{title}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      );
    },
  };
}
